// extracted by mini-css-extract-plugin
export var CYCLE = "Logo-module--CYCLE--4a03b";
export var animate = "Logo-module--animate--c9193";
export var line = "Logo-module--line--90b2f";
export var location = "Logo-module--location--aaa98";
export var logo = "Logo-module--logo--35be7";
export var title = "Logo-module--title--674b4";